var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-chevron-first",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 16,
    height: 16,
    fill: "#0071b9",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M35.9,13.305l-5.365,5.984V16.723l4.056-4.531a.123.123,0,0,0,0-.164L30.536,7.5V4.933L35.9,10.916A1.787,1.787,0,0,1,35.9,13.305Z",
    transform: "translate(-27.358 -4.111)",
    fill: "#0071b9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    width: 2,
    height: 14,
    transform: "translate(11.039 1)",
    fill: "#0071b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.88ef6194c2a2550f4566567bb883f68d.svg";
export { ForwardRef as ReactComponent };